import { OptimizedTimeSheet, ProjectElementType } from "@planzone/dto";
import React from "react";

type AllocationData = {
  uuid: string;
  resourceUuid: string;
  percentComplete: number;
  allocatedHours: number;
};

function renderWithTreeCtx(
  timeSheet: OptimizedTimeSheet,
  isOpen: (key: string) => boolean,
  render: (
    projectElement: OptimizedTimeSheet["elements"][number],
    index: number,
  ) => React.JSX.Element,
): React.ReactNode[] {
  return timeSheet.elements.reduce<{
    ui: React.JSX.Element[];
    filteredCount: number;
    ctx: {
      [key: number]: {
        filtered: boolean;
      };
    };
  }>(
    ({ ui, ctx, filteredCount }, projectElement, index) => {
      const isChangingDepth =
        projectElement.type === ProjectElementType.LIST &&
        timeSheet.elements[index + 1]?.depth !== projectElement.depth;
      const filtered = ctx[projectElement.depth - 1]?.filtered;

      return {
        filteredCount: !filtered ? filteredCount : filteredCount + 1,
        ui: !filtered ? [...ui, render(projectElement, index)] : ui,
        ctx: isChangingDepth
          ? {
              ...ctx,
              [projectElement.depth]: {
                filtered: filtered || !isOpen(projectElement.uuid),
              },
            }
          : ctx,
      };
    },
    {
      filteredCount: 0,
      ui: [],
      ctx: {},
    },
  ).ui;
}

function isLastIncompleteAllocation(
  allocations: AllocationData[],
  allocation: AllocationData,
): boolean {
  const nonCompleteAllocations = allocations.filter(
    (a) => a.percentComplete !== 100,
  );

  return (
    nonCompleteAllocations.length === 1 &&
    nonCompleteAllocations[0].uuid === allocation.uuid &&
    allocation.percentComplete !== 100
  );
}

export { renderWithTreeCtx };
